<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24" fill="none" {...$$restProps}>
	<g clip-path="url(#clip0_932_1098)">
		<path
			d="M17.0588 7H13.0588V9H17.0588C18.7088 9 20.0588 10.35 20.0588 12C20.0588 13.65 18.7088 15 17.0588 15H13.0588V17H17.0588C19.8188 17 22.0588 14.76 22.0588 12C22.0588 9.24 19.8188 7 17.0588 7ZM11.0588 15H7.05884C5.40884 15 4.05884 13.65 4.05884 12C4.05884 10.35 5.40884 9 7.05884 9H11.0588V7H7.05884C4.29884 7 2.05884 9.24 2.05884 12C2.05884 14.76 4.29884 17 7.05884 17H11.0588V15ZM8.05884 11H16.0588V13H8.05884V11Z"
			fill="#4E260D"
		/>
	</g>
	<defs>
		<clipPath id="clip0_932_1098">
			<rect width="24" height="24" fill="white" transform="translate(0.0588379)" />
		</clipPath>
	</defs>
</svg>
